/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AgentTool } from './AgentTool';
import {
    AgentToolFromJSON,
    AgentToolFromJSONTyped,
    AgentToolToJSON,
} from './AgentTool';
import type { CallingIdentity } from './CallingIdentity';
import {
    CallingIdentityFromJSON,
    CallingIdentityFromJSONTyped,
    CallingIdentityToJSON,
} from './CallingIdentity';

/**
 * Extends structures with details about when the resource was created/updated
 * @export
 * @interface AgentDetails
 */
export interface AgentDetails {
    /**
     * Name of the agent
     * @type {string}
     * @memberof AgentDetails
     */
    name: string;
    /**
     * Description for the agent
     * @type {string}
     * @memberof AgentDetails
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDetails
     */
    greeting: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDetails
     */
    language: string;
    /**
     * Tools attached to an agent
     * @type {Array<AgentTool>}
     * @memberof AgentDetails
     */
    tools?: Array<AgentTool>;
    /**
     * The time at which the resource was created
     * @type {number}
     * @memberof AgentDetails
     */
    createdAt: number;
    /**
     * The time of the most recent update
     * @type {number}
     * @memberof AgentDetails
     */
    updatedAt: number;
    /**
     * 
     * @type {CallingIdentity}
     * @memberof AgentDetails
     */
    createdBy: CallingIdentity;
    /**
     * 
     * @type {CallingIdentity}
     * @memberof AgentDetails
     */
    updatedBy: CallingIdentity;
    /**
     * Identifier for a TrusstedAgent
     * @type {string}
     * @memberof AgentDetails
     */
    agentId: string;
}


/**
 * Check if a given object implements the AgentDetails interface.
 */
export function instanceOfAgentDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "greeting" in value;
    isInstance = isInstance && "language" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;
    isInstance = isInstance && "createdBy" in value;
    isInstance = isInstance && "updatedBy" in value;
    isInstance = isInstance && "agentId" in value;

    return isInstance;
}

export function AgentDetailsFromJSON(json: any): AgentDetails {
    return AgentDetailsFromJSONTyped(json, false);
}

export function AgentDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgentDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'greeting': json['greeting'],
        'language': json['language'],
        'tools': !exists(json, 'tools') ? undefined : ((json['tools'] as Array<any>).map(AgentToolFromJSON)),
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'createdBy': CallingIdentityFromJSON(json['createdBy']),
        'updatedBy': CallingIdentityFromJSON(json['updatedBy']),
        'agentId': json['agentId'],
    };
}

export function AgentDetailsToJSON(value?: AgentDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'greeting': value.greeting,
        'language': value.language,
        'tools': value.tools === undefined ? undefined : ((value.tools as Array<any>).map(AgentToolToJSON)),
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'createdBy': CallingIdentityToJSON(value.createdBy),
        'updatedBy': CallingIdentityToJSON(value.updatedBy),
        'agentId': value.agentId,
    };
}

